var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.48633H11V7.48633H9V5.48633ZM9 9.48633H11V15.4863H9V9.48633ZM10 0.486328C4.48 0.486328 0 4.96633 0 10.4863C0 16.0063 4.48 20.4863 10 20.4863C15.52 20.4863 20 16.0063 20 10.4863C20 4.96633 15.52 0.486328 10 0.486328ZM10 18.4863C5.59 18.4863 2 14.8963 2 10.4863C2 6.07633 5.59 2.48633 10 2.48633C14.41 2.48633 18 6.07633 18 10.4863C18 14.8963 14.41 18.4863 10 18.4863Z",
    fill: "#F6F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBlue);
export default __webpack_public_path__ + "static/media/info_icon_blue.e98b08a3a7095a151f4ec2891cb8b326.svg";
export { ForwardRef as ReactComponent };